import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const DetailViewPage = React.lazy(() =>
  import("../pages/DetailView/DetailViewPage")
);

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        params={params}
        location={location}
        navigate={navigate}
      />
    );
  }

  return ComponentWithRouterProp;
}

const DetailViewPageWrapper = () => {
  const params = useParams();
  const match = {
    params: params,
  };
  return <DetailViewPage match={match} params={params} />;
};

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

const getApproximativeTextWidth = (text, isTextUppercase, element) => {
  // re-use canvas object for better performance
  const canvas =
    getApproximativeTextWidth.canvas ||
    (getApproximativeTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font = getCanvasFont(element ?? undefined);
  const metrics = context.measureText(text);
  const width = isTextUppercase
    ? metrics.width + metrics.width * 0.1
    : metrics.width;
  return !isNaN(width) ? Number(width) : width;

  function getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
  }

  function getCanvasFont(el = document.body) {
    const fontWeight = getCssStyle(el, "font-weight") || "normal";
    const fontSize = getCssStyle(el, "font-size") || "12px";
    const fontFamily = getCssStyle(el, "font-family") || "sans-serif";
    return `${fontWeight} ${fontSize} ${fontFamily}`;
  }
};

export {
  withRouter,
  DetailViewPageWrapper,
  withParams,
  getApproximativeTextWidth,
};
